import {call, fork, put, take} from 'redux-saga/effects';
import get from 'lodash/get';

import {
    GET_ALL_REQUESTER_CASES,
    UPDATE_REQUESTER_CASE,
    UPDATE_REQUESTER_CASE_AGENT_PAGE,
    UPDATE_REQUESTER_CASE_OPTION,
    CREATE_TICKET,
    CREATE_REQUESTER_CASE,
    UPDATE_CHECKED_SECTIONS,
    GET_REQUESTER_CASE,
    GET_REQUESTER_CASE_CLIENT,
    UPLOAD_REQUESTER_DOCUMENT,
    DELETE_REQUESTER_DOCUMENT,
    UPLOAD_REQUESTER_SIGNATURE,
    REQUESTER_PREPARED_STATUS,
    REQUEST_CASE_ASSIGN_AGENT,
    REQUEST_CASE_UNASSIGNED_AGENT,
    REQUEST_CASE_CHANGE_STATUS,
    REQUEST_CASE_CHAT_ACTIVATE,
    REQUEST_CASE_PINNING,
    REQUEST_CASE_ADD_TAG,
    REQUEST_CASE_REMOVE_TAG,
    REQUEST_CASE_ARCHIVE,
    REQUEST_CASE_QUESTION,
    REQUEST_CASE_ACTIVITIES,
    REQUEST_CASE_ACTIVITIES_EXPORT,
    REQUEST_CASE_ATTACHMENTS_FOR_ARCHIVE,
    REQUESTER_CASE_EMAIL_REQUEST,
    UPDATE_STATUS_CHANGE_APPROVE_REQUEST,
    UNSET_STATUS_CHANGE_APPROVE_REQUEST,
    DELETE_ALL_STATUS_CHANGE_APPROVE_REQUESTS,
    getAllRequesterCases,
    getRequesterCase,
    createTicket,
    getRequesterCaseForClient,
    createRequesterCase,
    updateRequesterCase,
    updateRequesterCaseAgentPage,
    updateRequesterCaseOption,
    updateCheckedSections,
    uploadRequesterCase,
    deleteRequesterCase,
    requesterPreparedStatus,
    requestCaseAssignAgent,
    requestCaseUnassignedAgent,
    requestCaseChangeStatus,
    requestCaseChatActivate,
    requestCasePinning,
    addRequesterTag,
    deleteRequesterTag,
    requesterArchiveDownload,
    requestCaseQuestion,
    getRequestCaseActivities,
    exportRequestCaseActivities,
    getRequestCaseAttachmentsForArchive,
    CREATE_CASE_WATCHER,
    createCaseWatcher,
    DELETE_CASE_WATCHER,
    deleteCaseWatcher,
    requesterCaseEmailRequest,
    editRequesterCase,
    EDIT_REQUESTER_DOCUMENT,
    uploadRequesterSignature,
    DELETE_REQUESTER_SIGNATURE,
    deleteRequesterSignature,
    updateStatusChangeApproveRequest,
    unsetStatusChangeApproveRequest,
    deleteAllStatusChangeApproveRequests,
    CREATE_ADDITIONAL_FORM_INVITE,
    createAdditionalFormInvite,
    DELETE_ADDITIONAL_FORM_INVITE,
    deleteAdditionalFormInvite,
    IGNORE_CASE_HAS_TASK,
    ignoreCaseHasTask,
    CREATE_SUBFORM_REQUEST,
    createSubFormRequest,
    SUBMIT_SUBFORM_REQUEST,
    submitSubFormRequest,
    DELETE_SUBFORM_REQUEST,
    deleteSubFormRequest,
    REQUEST_CASE_TOGGLE_REMOVING_POSSIBILITY,
    toggleRequesterCaseRemovingPossibility,
    GET_REQUESTER_CASE_ALL_FILES,
    getRequesterCaseAllFiles,
    GET_REQUESTER_CASE_CHAT_FILES,
    getRequesterCaseChatFiles,
    GET_REQUESTER_CASE_DRAWER,
    getRequesterCaseDrawerInfo,
    REQUEST_CASE_CANCEL,
    cancelRequesterCase,
    REQUEST_CASE_REMOVING,
    requesterCaseRemoving,
    UPDATE_CHECKED_SECTIONS_FOR_STACK,
    updateCheckedSectionsForStack,
    REQUESTER_CASE_SLOTS_LIST,
    getRequesterCaseSlotsList,
    CREATE_REQUESTER_CASE_HAS_SLOT,
    createRequesterCaseHasSlot,
    DELETE_REQUESTER_CASE_HAS_SLOT,
    deleteRequesterCaseHasSlot,
    REQUESTER_CASE_BUDGETS_LIST,
    getRequesterCaseBudgetsList,
    CREATE_REQUESTER_CASE_BUDGET,
    createRequesterCaseBudget,
    UPDATE_REQUESTER_CASE_BUDGET,
    updateRequesterCaseBudget,
    DELETE_REQUESTER_CASE_BUDGET,
    deleteRequesterCaseBudget,
    REQUESTER_CASE_CALENDARS_LIST,
    getRequesterCaseCalendarsList,
    CREATE_REQUESTER_CASE_CALENDAR,
    createRequesterCaseCalendar,
    UPDATE_REQUESTER_CASE_CALENDAR,
    updateRequesterCaseCalendar,
    DELETE_REQUESTER_CASE_CALENDAR,
    deleteRequesterCaseCalendar,
    GET_UNAVAILABLE_CALENDAR_RANGES,
    getUnavailableCalendarRanges,
    GET_REQUESTER_CASE_POPUPS,
    getRequesterCasePopups,
    CREATE_REQUESTER_POPUP,
    createRequesterPopup,
    updateRequesterPopup,
    deleteRequesterPopup,
    DELETE_REQUESTER_POPUP,
    UPDATE_REQUESTER_POPUP,
    UPDATE_REQUESTER_CASE_POPUP_OPTION,
    updateRequesterCasePopupOption,
    getRequesterCaseTimeBucketsList,
    REQUESTER_CASE_TIME_BUCKETS_LIST,
    DELETE_REQUESTER_CASE_TIME_BUCKET,
    UPDATE_REQUESTER_CASE_TIME_BUCKET,
    CREATE_REQUESTER_CASE_TIME_BUCKET,
    createRequesterCaseTimeBucket,
    updateRequesterCaseTimeBucket,
    deleteRequesterCaseTimeBucket,
    GET_TICKET_CASE,
    getTicketCase,
    CREATE_IMPERSONATED_CASE,
    createImpersonatedForm,
    UPDATE_IMPERSONATED_CASE_DETAILS,
    updateImpersonatedCaseDetails,
    REASSIGN_IMPERSONATED_CASE,
    reassignImpersonatedCase,
} from 'appRedux/actions/requestCase';
import {
    RequesterCaseResponseTypes,
    RequesterCaseTypes,
    TicketCreateRequestTypes,
    TicketCreateResponseTypes,
    RequesterCaseGettingTypes,
    RequesterCaseUpdatingTypes,
    RequesterCaseOptionUpdatingTypes,
    RequestCaseTagRequestTypes,
    UpdateCheckedSectionRequestTypes,
    UploadRequesterCaseTypes,
    DeleteRequesterDocumentTypes,
    RequesterPreparedStatusType,
    RequestCaseChangeStatusType,
    RequestCaseAssignAgentType,
    RequestCaseUnassignedAgentType,
    RequestCaseChatActivateRequestTypes,
    RequesterCaseCreateRequestTypes,
    RequesterCaseCreateResponseTypes,
    RequesterCaseTagResponseTypes,
    RequesterCaseDownloadArchiveTypes,
    UpdateCheckedSectionResponseTypes,
    RequesterCaseActivitiesRequestTypes,
    RequesterCaseActivitiesResponseTypes,
    RequestCaseQuestionRequestTypes,
    RequestCaseQuestionResponseTypes,
    RequesterCaseActivitiesTypes,
    RequesterCaseAttachmentsForArchiveResponseTypes,
    RequesterCaseActivitiesExportRequestTypes,
    CaseWatcherCreatingTypes,
    CaseWatcherResponseTypes,
    CaseWatcherRemovingTypes,
    RequesterCaseEmailRequestTypes,
    RequesterCaseEmailResponseTypes,
    EditRequesterDocumentTypes,
    UploadRequesterSignatureTypes,
    DeleteRequesterSignatureTypes,
    StatusChangeApproveUpdateRequestType,
    UnsetStatusChangeApproveRequestType,
    DeleteAllStatusChangeApproveRequestType,
    StatusChangeApproveResponseType,
    InviteAdditionalFormCreateRequestTypes,
    InviteAdditionalFormDeleteRequestTypes,
    InviteAdditionalFormResponseTypes,
    SubFormRequestsResponseTypes,
    SubFormRequestDeleteRequestTypes,
    SubFormRequestSubmittingRequestTypes,
    CaseHasTaskIgnoringTypes,
    CaseHasTaskResponseTypes,
    RequesterCaseToggleRemovingPossibilityRequestTypes,
    UpdatedCaseListItemType,
    CommonResponseType,
    RequesterCaseUpdateResponse,
    RequesterCaseFilesResponseTypes,
    RequesterCaseChatFilesResponseTypes,
    RequesterCaseDrawerResponseTypes,
    RequesterCaseSlotsListRequestTypes,
    RequesterCaseHasSlotCreationRequestTypes,
    RequesterCaseHasSlotDeletingRequestTypes,
    RequesterCaseSlotsResponseTypes,
    RequesterCaseBudgetsListRequestTypes,
    RequesterCaseBudgetCreateRequestTypes,
    RequesterCaseBudgetUpdateRequestTypes,
    RequesterCaseBudgetDeleteRequestTypes,
    RequesterCaseBudgetsResponseTypes,
    RequesterCaseCancelingRequestTypes,
    RequesterCaseRemovingRequestTypes,
    RequesterCaseRemovingResponseTypes,
    RequesterCaseCalendarsListRequestTypes,
    RequesterCaseCalendarCreateRequestTypes,
    RequesterCaseCalendarUpdateRequestTypes,
    RequesterCaseCalendarDeleteRequestTypes,
    RequesterCaseCalendarsResponseTypes,
    CalendarUnavailableRangesRequestTypes,
    CalendarUnavailableRangesResponseTypes,
    RequesterCasePopupsResponseTypes,
    RequesterCasePopupCreatingTypes,
    RequesterCasePopupUpdatingTypes,
    RequesterCasePopupDeletingTypes,
    RequesterCasePopupOptionUpdatingTypes,
    RequesterCaseTimeBucketsListRequestTypes,
    RequesterCaseTimeBucketsResponseTypes,
    RequesterCaseTimeBucketCreateRequestTypes,
    RequesterCaseTimeBucketUpdateRequestTypes,
    RequesterCasesResponseTypes,
    RequesterPreparedStatusResponseTypes,
    ImpersonatedFormCreationRequestTypes,
    ImpersonatedCaseRedirectResponseTypes,
    ImpersonatedFormUpdatingRequestTypes,
    ImpersonatedFormUpdatingResponseTypes,
    ImpersonatedCaseReassignRequestTypes,
} from 'appRedux/actions/requestCase/types';
import {
    RequesterDocumentUploadResponseType,
    RequesterSignatureUploadResponseType,
} from 'appRedux/actions/profile/types';

import {ALERT_TYPE_ERROR, ALERT_TYPE_SUCCESS} from 'config/index';
import {
    ERROR_OUTDATED_INFORMATION,
    ERROR_SECTION_ALREADY_CHECKED,
    ERROR_MESSAGE_WRONG_DOCUMENT_SIZE,
    ERROR_MESSAGE_WRONG_DOCUMENT_TYPE,
    ERROR_INFECTED_FILE,
} from 'config/errors';

import {http} from 'services/http';

function* watchGetAllRequesterCases() {
    while (true) {
        const {
            payload: {id},
        }: IActionType<RequesterCaseGettingTypes> = yield take(GET_ALL_REQUESTER_CASES.REQUEST);
        try {
            const data: RequesterCasesResponseTypes = yield call(http, `user/${id}/cases`, {
                method: 'GET',
            });
            if (data) {
                yield put(getAllRequesterCases.success(data.results));
            } else {
                yield put(getAllRequesterCases.error({message: 'messages.error.somethingWentWrong'}));
            }
        } catch (e) {
            yield put(getAllRequesterCases.error({message: String(e)}));
        }
    }
}

function* watchGetAllRequesterCasesBackground() {
    while (true) {
        const {
            payload: {id},
        }: IActionType<RequesterCaseGettingTypes> = yield take(GET_ALL_REQUESTER_CASES.REQUEST_BACKGROUND);
        try {
            const data: RequesterCasesResponseTypes = yield call(http, `user/${id}/cases`, {
                method: 'GET',
            });
            if (data) {
                yield put(getAllRequesterCases.success(data.results));
            } else {
                yield put(getAllRequesterCases.error({message: 'messages.error.somethingWentWrong'}));
            }
        } catch (e) {
            yield put(getAllRequesterCases.error({message: String(e)}));
        }
    }
}

function* watchCaseFilesRequestGetting() {
    while (true) {
        const {
            payload: {id, showAlert, callback},
        }: IActionType<RequesterCaseGettingTypes> = yield take(GET_REQUESTER_CASE_ALL_FILES.REQUEST);
        try {
            const data: RequesterCaseFilesResponseTypes = yield call(http, `case/${id}/files`, {
                method: 'GET',
            });
            if (data.success) {
                yield put(getRequesterCaseAllFiles.success(data.results));
                callback && callback();
            } else {
                yield put(getRequesterCaseAllFiles.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(getRequesterCaseAllFiles.error({message: String(e)}));
        }
    }
}

function* watchCaseChatFilesRequestGetting() {
    while (true) {
        const {
            payload: {id, showAlert, callback},
        }: IActionType<RequesterCaseGettingTypes> = yield take(GET_REQUESTER_CASE_CHAT_FILES.REQUEST);
        try {
            const data: RequesterCaseChatFilesResponseTypes = yield call(http, `case/${id}/chat/files`, {
                method: 'GET',
            });
            if (data.success) {
                yield put(getRequesterCaseChatFiles.success(data.results));
                callback && callback();
            } else {
                yield put(getRequesterCaseChatFiles.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(getRequesterCaseChatFiles.error({message: String(e)}));
        }
    }
}

function* watchRequesterCaseToggleRemovingPossibility() {
    while (true) {
        const {
            payload: {id, showAlert, callback},
        }: IActionType<RequesterCaseToggleRemovingPossibilityRequestTypes> = yield take(
            REQUEST_CASE_TOGGLE_REMOVING_POSSIBILITY.REQUEST,
        );
        try {
            const data: UpdatedCaseListItemType = yield call(http, `case/${id}/remove/impossible`, {
                method: 'POST',
            });
            if (data.success) {
                yield put(toggleRequesterCaseRemovingPossibility.success(data.requesterCase));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(toggleRequesterCaseRemovingPossibility.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(toggleRequesterCaseRemovingPossibility.error({message: String(e)}));
        }
    }
}

function* watchRequesterCaseCanceling() {
    while (true) {
        const {
            payload: {id, showAlert, callback, ...values},
        }: IActionType<RequesterCaseCancelingRequestTypes> = yield take(REQUEST_CASE_CANCEL.REQUEST);
        try {
            const data: UpdatedCaseListItemType = yield call(http, `case/${id}/cancel`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(cancelRequesterCase.success(data.requesterCase));
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
                callback && callback();
            } else {
                yield put(cancelRequesterCase.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(cancelRequesterCase.error({message: String(e)}));
        }
    }
}

function* watchRequesterCaseRemoving() {
    while (true) {
        const {
            payload: {id, showAlert, callback},
        }: IActionType<RequesterCaseRemovingRequestTypes> = yield take(REQUEST_CASE_REMOVING.REQUEST);
        try {
            const data: RequesterCaseRemovingResponseTypes = yield call(http, `case/${id}/remove`, {
                method: 'POST',
            });
            if (data.success) {
                yield put(requesterCaseRemoving.success(data.caseId));
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
                callback && callback();
            } else {
                yield put(requesterCaseRemoving.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(requesterCaseRemoving.error({message: String(e)}));
        }
    }
}

function* watchGetRequesterCase() {
    while (true) {
        const {
            payload: {id},
        }: IActionType<RequesterCaseGettingTypes> = yield take(GET_REQUESTER_CASE.REQUEST);
        try {
            const data: RequesterCaseTypes = yield call(http, `case/${id}/information`, {
                method: 'GET',
            });
            const caseInformation = get(data, ['case'], {});
            const result = get(data, ['case', 'result'], null);
            const resultAgent = get(data, ['case', 'resultAgent'], null);
            const checkedSections = get(data, 'checkedSections', []);
            const chatFiles = get(data, 'chatFiles', []);
            const notReadMessages = get(data, 'notReadMessages', 0);
            const totalFilesNumber = get(data, 'totalFilesNumber', 0);
            const translations = get(data, 'translations', []);
            const files = get(data, 'files', []);
            const tags = get(data, 'tags', []);
            const templates = get(data, 'templates', []);
            const options = get(data, 'options', []);
            const watchers = get(data, ['watchers'], {});
            const signatures = get(data, 'signatures', []);
            const invites = get(data, 'invites', []);
            const subFormRequests = get(data, 'subFormRequests', []);
            const tasks = get(data, 'tasks', []);
            yield put(
                getRequesterCase.success({
                    ...caseInformation,
                    result: result ? JSON.parse(result) : null,
                    resultAgent: resultAgent ? JSON.parse(resultAgent) : null,
                    checkedSections,
                    chatFiles,
                    notReadMessages,
                    totalFilesNumber,
                    translations,
                    files,
                    tags,
                    templates,
                    options,
                    watchers,
                    signatures,
                    invites,
                    subFormRequests,
                    tasks,
                }),
            );
        } catch (e) {
            yield put(getRequesterCase.error({message: String(e)}));
        }
    }
}

function* watchGetRequesterCaseForClient() {
    while (true) {
        const {
            payload: {id},
        }: IActionType<RequesterCaseGettingTypes> = yield take(GET_REQUESTER_CASE_CLIENT.REQUEST);
        try {
            const data: RequesterCaseTypes = yield call(http, `requester/case/${id}/information`, {
                method: 'GET',
            });
            const caseInformation = get(data, ['case'], {});
            const result = get(data, ['case', 'result'], null);
            const checkedSections = get(data, 'checkedSections', []);
            const chatFiles = get(data, 'chatFiles', []);
            const notReadMessages = get(data, 'notReadMessages', 0);
            const totalFilesNumber = get(data, 'totalFilesNumber', 0);
            const translations = get(data, 'translations', []);
            const files = get(data, 'files', []);
            const templates = get(data, 'templates', []);
            const options = get(data, 'options', []);
            const signatures = get(data, 'signatures', []);
            const subFormRequests = get(data, 'subFormRequests', []);
            yield put(
                getRequesterCaseForClient.success({
                    ...caseInformation,
                    result: result ? JSON.parse(result) : null,
                    checkedSections,
                    chatFiles,
                    notReadMessages,
                    totalFilesNumber,
                    translations,
                    files,
                    templates,
                    options,
                    signatures,
                    subFormRequests,
                }),
            );
        } catch (e) {
            yield put(getRequesterCaseForClient.error({message: String(e)}));
        }
    }
}

function* watchGetTicketCase() {
    while (true) {
        const {
            payload: {id},
        }: IActionType<RequesterCaseGettingTypes> = yield take(GET_TICKET_CASE.REQUEST);
        try {
            const data: RequesterCaseTypes = yield call(http, `ticket/${id}/information`, {
                method: 'GET',
            });
            const caseInformation = get(data, ['case'], {});
            const result = get(data, ['case', 'result'], null);
            const resultAgent = get(data, ['case', 'resultAgent'], null);
            const checkedSections = get(data, 'checkedSections', []);
            const chatFiles = get(data, 'chatFiles', []);
            const notReadMessages = get(data, 'notReadMessages', 0);
            const totalFilesNumber = get(data, 'totalFilesNumber', 0);
            const translations = get(data, 'translations', []);
            const files = get(data, 'files', []);
            const tags = get(data, 'tags', []);
            const templates = get(data, 'templates', []);
            const options = get(data, 'options', []);
            const watchers = get(data, ['watchers'], {});
            const signatures = get(data, 'signatures', []);
            const invites = get(data, 'invites', []);
            const subFormRequests = get(data, 'subFormRequests', []);
            const tasks = get(data, 'tasks', []);
            yield put(
                getTicketCase.success({
                    ...caseInformation,
                    result: result ? JSON.parse(result) : null,
                    resultAgent: resultAgent ? JSON.parse(resultAgent) : null,
                    checkedSections,
                    chatFiles,
                    notReadMessages,
                    totalFilesNumber,
                    translations,
                    files,
                    tags,
                    templates,
                    options,
                    watchers,
                    signatures,
                    invites,
                    subFormRequests,
                    tasks,
                }),
            );
        } catch (e) {
            yield put(getTicketCase.error({message: String(e)}));
        }
    }
}

function* watchGetRequesterCaseDrawer() {
    while (true) {
        const {
            payload: {id, showAlert},
        }: IActionType<RequesterCaseGettingTypes> = yield take(GET_REQUESTER_CASE_DRAWER.REQUEST);
        try {
            const data: RequesterCaseDrawerResponseTypes = yield call(http, `case/${id}/drawer`, {
                method: 'GET',
            });
            if (data.success) {
                yield put(getRequesterCaseDrawerInfo.success(data.result));
            } else {
                yield put(getRequesterCaseDrawerInfo.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(getRequesterCaseDrawerInfo.error({message: String(e)}));
        }
    }
}

function* watchGetRequesterCaseBackground() {
    while (true) {
        const {
            payload: {id},
        }: IActionType<RequesterCaseGettingTypes> = yield take(GET_REQUESTER_CASE.REQUEST_BACKGROUND);
        try {
            const data: RequesterCaseTypes = yield call(http, `case/${id}/information`, {
                method: 'GET',
            });
            const caseInformation = get(data, ['case'], {});
            const result = get(data, ['case', 'result'], null);
            const resultAgent = get(data, ['case', 'resultAgent'], null);
            const checkedSections = get(data, 'checkedSections', []);
            const chatFiles = get(data, 'chatFiles', []);
            const notReadMessages = get(data, 'notReadMessages', 0);
            const totalFilesNumber = get(data, 'totalFilesNumber', 0);
            const translations = get(data, 'translations', []);
            const files = get(data, 'files', []);
            const tags = get(data, 'tags', []);
            const templates = get(data, 'templates', []);
            const options = get(data, 'options', []);
            const watchers = get(data, ['watchers'], {});
            const signatures = get(data, 'signatures', []);
            const invites = get(data, 'invites', []);
            const subFormRequests = get(data, 'subFormRequests', []);
            const tasks = get(data, 'tasks', []);
            yield put(
                getRequesterCase.success({
                    ...caseInformation,
                    result: result ? JSON.parse(result) : null,
                    resultAgent: resultAgent ? JSON.parse(resultAgent) : null,
                    checkedSections,
                    chatFiles,
                    notReadMessages,
                    totalFilesNumber,
                    translations,
                    files,
                    tags,
                    templates,
                    options,
                    watchers,
                    signatures,
                    invites,
                    subFormRequests,
                    tasks,
                }),
            );
        } catch (e) {
            yield put(getRequesterCase.error({message: String(e)}));
        }
    }
}

function* watchGetRequesterCaseBackgroundForClient() {
    while (true) {
        const {
            payload: {id},
        }: IActionType<RequesterCaseGettingTypes> = yield take(GET_REQUESTER_CASE_CLIENT.REQUEST_BACKGROUND);
        try {
            const data: RequesterCaseTypes = yield call(http, `requester/case/${id}/information`, {
                method: 'GET',
            });
            const caseInformation = get(data, ['case'], {});
            const result = get(data, ['case', 'result'], null);
            const checkedSections = get(data, 'checkedSections', []);
            const chatFiles = get(data, 'chatFiles', []);
            const notReadMessages = get(data, 'notReadMessages', 0);
            const totalFilesNumber = get(data, 'totalFilesNumber', 0);
            const translations = get(data, 'translations', []);
            const files = get(data, 'files', []);
            const templates = get(data, 'templates', []);
            const options = get(data, 'options', []);
            const signatures = get(data, 'signatures', []);
            const subFormRequests = get(data, 'subFormRequests', []);
            yield put(
                getRequesterCaseForClient.success({
                    ...caseInformation,
                    result: result ? JSON.parse(result) : null,
                    checkedSections,
                    chatFiles,
                    notReadMessages,
                    totalFilesNumber,
                    translations,
                    files,
                    templates,
                    options,
                    signatures,
                    subFormRequests,
                }),
            );
        } catch (e) {
            yield put(getRequesterCaseForClient.error({message: String(e)}));
        }
    }
}

function* watchCreateTicket() {
    while (true) {
        const {
            payload: {formId, callback, showAlert},
        }: IActionType<TicketCreateRequestTypes> = yield take(CREATE_TICKET.REQUEST);
        try {
            const data: TicketCreateResponseTypes = yield call(http, `ticket/${formId}/create`, {
                method: 'POST',
            });
            if (data.success) {
                const caseInformation = get(data.result, ['case'], {});
                const result = get(data.result, ['case', 'result'], null);
                const resultAgent = get(data.result, ['case', 'resultAgent'], null);
                const checkedSections = get(data.result, 'checkedSections', []);
                const chatFiles = get(data.result, 'chatFiles', []);
                const notReadMessages = get(data.result, 'notReadMessages', 0);
                const totalFilesNumber = get(data.result, 'totalFilesNumber', 0);
                const translations = get(data.result, 'translations', []);
                const files = get(data.result, 'files', []);
                const tags = get(data.result, 'tags', []);
                const templates = get(data, 'templates', []);
                const options = get(data.result, 'options', []);
                const watchers = get(data.result, ['watchers'], {});
                const signatures = get(data.result, 'signatures', []);
                const invites = get(data.result, 'invites', []);
                const subFormRequests = get(data.result, 'subFormRequests', []);
                const tasks = get(data.result, 'tasks', []);
                yield put(
                    createTicket.success({
                        ...caseInformation,
                        result: result ? JSON.parse(result) : null,
                        resultAgent: resultAgent ? JSON.parse(resultAgent) : null,
                        checkedSections,
                        chatFiles,
                        notReadMessages,
                        totalFilesNumber,
                        translations,
                        files,
                        tags,
                        templates,
                        options,
                        watchers,
                        signatures,
                        invites,
                        subFormRequests,
                        tasks,
                    }),
                );
                yield put(createTicket.success(data.result));
                callback && callback(caseInformation.id);
            } else {
                yield put(createTicket.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(createTicket.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchCreateRequestCase() {
    while (true) {
        const {
            payload: {formId, callback, invite, showAlert},
        }: IActionType<RequesterCaseCreateRequestTypes> = yield take(CREATE_REQUESTER_CASE.REQUEST);
        try {
            const data: RequesterCaseCreateResponseTypes = yield call(http, `case/${formId}/create`, {
                method: 'POST',
                body: JSON.stringify({invite}),
            });
            if (data.success) {
                yield put(createRequesterCase.success(data));
                callback && callback(data.caseId);
            } else if (data.errors) {
                yield put(createRequesterCase.error({message: data.errors}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            } else {
                yield put(createRequesterCase.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(createRequesterCase.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchUpdateRequesterCase() {
    while (true) {
        const {
            payload: {id, callback, result, sectionId, pageId, toggleSectionChecked, showAlert},
        }: IActionType<RequesterCaseUpdatingTypes> = yield take(UPDATE_REQUESTER_CASE.REQUEST);
        try {
            const data: RequesterCaseUpdateResponse = yield call(http, `case/${id}/update`, {
                method: 'POST',
                body: JSON.stringify({
                    result: JSON.stringify(result),
                    sectionId,
                    pageId,
                }),
            });
            if (data.success) {
                yield put(updateRequesterCase.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else if (data.errors === ERROR_SECTION_ALREADY_CHECKED) {
                yield put(updateRequesterCase.error({message: ERROR_SECTION_ALREADY_CHECKED}));
                toggleSectionChecked && toggleSectionChecked();
            } else {
                yield put(updateRequesterCase.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(updateRequesterCase.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchUpdateRequesterCaseAgentPage() {
    while (true) {
        const {
            payload: {id, callback, resultAgent, sectionId, pageId, toggleSectionChecked, showAlert},
        }: IActionType<RequesterCaseUpdatingTypes> = yield take(UPDATE_REQUESTER_CASE_AGENT_PAGE.REQUEST);
        try {
            const data: RequesterCaseUpdateResponse = yield call(http, `case/${id}/update/interactive`, {
                method: 'POST',
                body: JSON.stringify({
                    resultAgent: JSON.stringify(resultAgent),
                    sectionId,
                    pageId,
                }),
            });
            if (data.success) {
                yield put(updateRequesterCaseAgentPage.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else if (data.errors === ERROR_SECTION_ALREADY_CHECKED) {
                yield put(updateRequesterCaseAgentPage.error({message: ERROR_SECTION_ALREADY_CHECKED}));
                toggleSectionChecked && toggleSectionChecked();
            } else {
                yield put(updateRequesterCaseAgentPage.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(updateRequesterCaseAgentPage.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchUpdateRequesterCaseOption() {
    while (true) {
        const {
            payload: {id, callback, showAlert, ...values},
        }: IActionType<RequesterCaseOptionUpdatingTypes> = yield take(UPDATE_REQUESTER_CASE_OPTION.REQUEST);
        try {
            const data: CommonResponseType = yield call(http, `case/${id}/update/option`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(updateRequesterCaseOption.success());
                callback && callback();
            } else {
                yield put(updateRequesterCaseOption.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(updateRequesterCase.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchUpdateRequesterCasePopupOption() {
    while (true) {
        const {
            payload: {id, callback, showAlert, ...values},
        }: IActionType<RequesterCasePopupOptionUpdatingTypes> = yield take(UPDATE_REQUESTER_CASE_POPUP_OPTION.REQUEST);
        try {
            const data: CommonResponseType = yield call(http, `case/${id}/update/popup/option`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(updateRequesterCasePopupOption.success());
                callback && callback();
            } else {
                yield put(updateRequesterCasePopupOption.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(updateRequesterCasePopupOption.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchUpdateCheckedSections() {
    while (true) {
        const {
            payload: {id, agentId, sectionId, readAt, showAlert, toggleOutdatedInfo},
        }: IActionType<UpdateCheckedSectionRequestTypes> = yield take(UPDATE_CHECKED_SECTIONS.REQUEST);
        try {
            const data: UpdateCheckedSectionResponseTypes = yield call(http, `agent/${id}/checked`, {
                method: 'POST',
                body: JSON.stringify({
                    agent: agentId,
                    section: sectionId,
                    readAt,
                }),
            });
            if (data.errors) {
                if (data.errors === ERROR_OUTDATED_INFORMATION) {
                    yield put(updateCheckedSections.error({message: ERROR_OUTDATED_INFORMATION}));
                    toggleOutdatedInfo && toggleOutdatedInfo();
                } else {
                    yield put(updateCheckedSections.error({message: 'messages.error.somethingWentWrong'}));
                    showAlert && showAlert(ALERT_TYPE_ERROR);
                }
            } else {
                yield put(updateCheckedSections.success(data.checkedSections));
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            }
        } catch (e) {
            yield put(updateCheckedSections.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchUpdateCheckedSectionsForStack() {
    while (true) {
        const {
            payload: {id, agentId, sectionId, readAt, showAlert, toggleOutdatedInfo},
        }: IActionType<UpdateCheckedSectionRequestTypes> = yield take(UPDATE_CHECKED_SECTIONS_FOR_STACK.REQUEST);
        try {
            const data: UpdateCheckedSectionResponseTypes = yield call(http, `agent/${id}/checked/stack`, {
                method: 'POST',
                body: JSON.stringify({
                    agent: agentId,
                    section: sectionId,
                    readAt,
                }),
            });
            if (data.errors) {
                if (data.errors === ERROR_OUTDATED_INFORMATION) {
                    yield put(updateCheckedSectionsForStack.error({message: ERROR_OUTDATED_INFORMATION}));
                    toggleOutdatedInfo && toggleOutdatedInfo();
                } else {
                    yield put(updateCheckedSectionsForStack.error({message: 'messages.error.somethingWentWrong'}));
                    showAlert && showAlert(ALERT_TYPE_ERROR);
                }
            } else {
                yield put(updateCheckedSectionsForStack.success(data.checkedSections));
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            }
        } catch (e) {
            yield put(updateCheckedSectionsForStack.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchRequesterPreparedStatus() {
    while (true) {
        const {
            payload: {id, showAlert, callback},
        }: IActionType<RequesterPreparedStatusType> = yield take(REQUESTER_PREPARED_STATUS.REQUEST);
        try {
            const data: RequesterPreparedStatusResponseTypes = yield call(http, `case/${id}/prepared`, {
                method: 'GET',
            });
            if (data.success) {
                yield put(requesterPreparedStatus.success(JSON.parse(data.result)));
                callback && callback();
            } else {
                yield put(requesterPreparedStatus.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(requesterPreparedStatus.error({message: String(e)}));
        }
    }
}

function* watchUploadFile() {
    while (true) {
        const {
            payload: {
                file,
                fileName,
                encryptPrefix,
                callbackError,
                callbackInfectedFileError,
                formId,
                fieldId,
                description,
                caseId,
                thumb,
                requesterCaseHasPopupId,
                sectionId,
                setErrors,
                callback,
                showAlert,
            },
        }: IActionType<UploadRequesterCaseTypes> = yield take(UPLOAD_REQUESTER_DOCUMENT.REQUEST);
        try {
            const formData = new FormData();
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            formData.append('media', file, fileName);
            formData.append('description', description);
            if (encryptPrefix) formData.append('encryptPrefix', encryptPrefix);
            if (thumb) formData.append('thumb', thumb);
            if (requesterCaseHasPopupId) formData.append('requesterCaseHasPopupId', String(requesterCaseHasPopupId));
            formData.append('formId', String(formId));
            formData.append('sectionId', String(sectionId));
            formData.append('fieldId', String(fieldId));
            const data: RequesterDocumentUploadResponseType = yield call(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                http,
                `user/case/${caseId}`,
                {
                    method: 'POST',
                    body: formData,
                },
            );

            const infectedFileMessage = get(data, ['errors', 'message'], null);

            if (data.success) {
                yield put(
                    uploadRequesterCase.success({
                        files: data.results,
                    }),
                );
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else if (data.errors === ERROR_SECTION_ALREADY_CHECKED) {
                yield put(uploadRequesterCase.error({message: ERROR_SECTION_ALREADY_CHECKED}));
                callbackError && callbackError();
            } else if (data.errors === ERROR_MESSAGE_WRONG_DOCUMENT_SIZE) {
                yield put(uploadRequesterCase.error({message: ERROR_MESSAGE_WRONG_DOCUMENT_SIZE}));
                showAlert && showAlert(ALERT_TYPE_ERROR, ERROR_MESSAGE_WRONG_DOCUMENT_SIZE);
            } else if (data.errors === ERROR_MESSAGE_WRONG_DOCUMENT_TYPE) {
                yield put(uploadRequesterCase.error({message: 'wrongDocumentTypeMessage'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, 'wrongDocumentTypeMessage');
            } else if (infectedFileMessage) {
                setErrors &&
                    setErrors({
                        file: ERROR_INFECTED_FILE,
                    });
                const attempts = get(data, ['errors', 'attempts'], 0);
                callbackInfectedFileError && callbackInfectedFileError(attempts ? Number(attempts) : null);
                yield put(uploadRequesterCase.error({message: ERROR_INFECTED_FILE}));
                showAlert && showAlert(ALERT_TYPE_ERROR, ERROR_INFECTED_FILE);
            } else {
                setErrors && setErrors(data.errors);
                yield put(uploadRequesterCase.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            yield put(uploadRequesterCase.error(e.toString()));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchUploadSignature() {
    while (true) {
        const {
            payload: {file, formId, fieldId, caseId, requesterCaseHasPopup, sectionId, callback, showAlert},
        }: IActionType<UploadRequesterSignatureTypes> = yield take(UPLOAD_REQUESTER_SIGNATURE.REQUEST);
        try {
            const formData = new FormData();
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            formData.append('media', file, 'signature');
            formData.append('form', String(formId));
            formData.append('section', String(sectionId));
            formData.append('field', String(fieldId));
            requesterCaseHasPopup && formData.append('requesterCaseHasPopup', String(requesterCaseHasPopup));

            const data: RequesterSignatureUploadResponseType = yield call(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                http,
                `case/${caseId}/signature/upload`,
                {
                    method: 'POST',
                    body: formData,
                },
            );

            if (data.success) {
                yield put(
                    uploadRequesterSignature.success({
                        signatures: data.results,
                    }),
                );
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(uploadRequesterCase.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            yield put(uploadRequesterCase.error(e.toString()));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchDeleteSignature() {
    while (true) {
        const {
            payload: {uuid, caseId, sectionId, toggleSectionChecked, callback},
        }: IActionType<DeleteRequesterSignatureTypes> = yield take(DELETE_REQUESTER_SIGNATURE.REQUEST);
        try {
            // TODO: WHAT RETURNS
            const data: RequesterSignatureUploadResponseType = yield call(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                http,
                `signature/${uuid}/delete`,
                {
                    method: 'delete',
                    body: JSON.stringify({
                        sectionId,
                        caseId,
                    }),
                },
            );

            if (data.success) {
                yield put(
                    deleteRequesterSignature.success({
                        signatures: data.results,
                    }),
                );
                callback && callback();
            } else {
                yield put(deleteRequesterSignature.error({message: 'messages.error.somethingWentWrong'}));
                toggleSectionChecked && toggleSectionChecked();
            }
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            yield put(profileInfoStep.error(e.toString()));
        }
    }
}

function* watchRequesterCasePopupsGetting() {
    while (true) {
        const {
            payload: {id, callback, showAlert},
        }: IActionType<RequesterCaseGettingTypes> = yield take(GET_REQUESTER_CASE_POPUPS.REQUEST);
        try {
            const data: RequesterCasePopupsResponseTypes = yield call(http, `case/popup/${id}/list`, {
                method: 'GET',
            });
            if (data.success) {
                yield put(getRequesterCasePopups.success(data.results));
                callback && callback();
            } else {
                yield put(getRequesterCasePopups.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(getRequesterCasePopups.error({message: String(e)}));
        }
    }
}

function* watchRequesterPopupCreating() {
    while (true) {
        const {
            payload: {id, callback, showAlert, ...otherData},
        }: IActionType<RequesterCasePopupCreatingTypes> = yield take(CREATE_REQUESTER_POPUP.REQUEST);
        try {
            const data: RequesterCasePopupsResponseTypes = yield call(http, `case/popup/${id}/create`, {
                method: 'POST',
                body: JSON.stringify({
                    ...otherData,
                }),
            });
            if (data.success) {
                yield put(createRequesterPopup.success(data.results));
                callback && callback();
            } else {
                yield put(createRequesterPopup.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(createRequesterPopup.error({message: String(e)}));
        }
    }
}

function* watchRequesterPopupUpdating() {
    while (true) {
        const {
            payload: {uuid, callback, showAlert, ...otherData},
        }: IActionType<RequesterCasePopupUpdatingTypes> = yield take(UPDATE_REQUESTER_POPUP.REQUEST);
        try {
            const data: RequesterCasePopupsResponseTypes = yield call(http, `case/popup/${uuid}/update`, {
                method: 'POST',
                body: JSON.stringify({
                    ...otherData,
                }),
            });
            if (data.success) {
                yield put(updateRequesterPopup.success(data.results));
                callback && callback();
            } else {
                yield put(updateRequesterPopup.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(updateRequesterPopup.error({message: String(e)}));
        }
    }
}

function* watchRequesterPopupDeleting() {
    while (true) {
        const {
            payload: {uuid, callback, showAlert},
        }: IActionType<RequesterCasePopupDeletingTypes> = yield take(DELETE_REQUESTER_POPUP.REQUEST);
        try {
            const data: RequesterCasePopupsResponseTypes = yield call(http, `case/popup/${uuid}/delete`, {
                method: 'DELETE',
            });
            if (data.success) {
                yield put(deleteRequesterPopup.success(data.results));
                callback && callback();
            } else {
                yield put(deleteRequesterPopup.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(deleteRequesterPopup.error({message: String(e)}));
        }
    }
}

function* watchDeleteProfileEntities() {
    while (true) {
        const {
            payload: {uuid, sectionId, caseId, toggleSectionChecked, callback},
        }: IActionType<DeleteRequesterDocumentTypes> = yield take(DELETE_REQUESTER_DOCUMENT.REQUEST);
        try {
            const data: RequesterDocumentUploadResponseType = yield call(http, `document/${uuid}/delete`, {
                method: 'POST',
                body: JSON.stringify({
                    sectionId,
                    caseId,
                }),
            });
            if (data.success) {
                yield put(deleteRequesterCase.success(uuid));
                callback && callback();
            } else if (data.errors === ERROR_SECTION_ALREADY_CHECKED) {
                yield put(updateRequesterCase.error({message: ERROR_SECTION_ALREADY_CHECKED}));
                toggleSectionChecked && toggleSectionChecked();
            } else {
                yield put(deleteRequesterCase.error({message: 'messages.error.somethingWentWrong'}));
            }
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            yield put(profileInfoStep.error(e.toString()));
        }
    }
}

function* watchEditProfileEntities() {
    while (true) {
        const {
            payload: {uuid, description, sectionId, caseId, toggleSectionChecked, callback, showAlert},
        }: IActionType<EditRequesterDocumentTypes> = yield take(EDIT_REQUESTER_DOCUMENT.REQUEST);
        try {
            const data: RequesterDocumentUploadResponseType = yield call(http, `document/${uuid}/edit`, {
                method: 'POST',
                body: JSON.stringify({
                    sectionId,
                    caseId,
                    description,
                }),
            });
            if (data.success) {
                yield put(
                    editRequesterCase.success({
                        files: data.results,
                    }),
                );
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else if (data.errors === ERROR_SECTION_ALREADY_CHECKED) {
                yield put(editRequesterCase.error({message: ERROR_SECTION_ALREADY_CHECKED}));
                toggleSectionChecked && toggleSectionChecked();
                showAlert && showAlert(ALERT_TYPE_ERROR);
            } else {
                yield put(editRequesterCase.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            yield put(profileInfoStep.error(e.toString()));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchRequestCaseAgentAssigning() {
    while (true) {
        const {
            payload: {agentId, caseId, callback, showAlert},
        }: IActionType<RequestCaseAssignAgentType> = yield take(REQUEST_CASE_ASSIGN_AGENT.REQUEST);
        try {
            const data: RequesterCaseResponseTypes = yield call(http, `case/${caseId}/assign`, {
                method: 'POST',
                body: JSON.stringify({
                    agent: agentId,
                }),
            });
            if (data.success) {
                const caseInformation = get(data, ['results', 'case'], {});
                const result = get(data, ['results', 'case', 'result'], null);
                const resultAgent = get(data, ['results', 'case', 'resultAgent'], null);
                const watchers = get(data, ['results', 'watchers'], []);
                const subFormRequests = get(data, ['results', 'subFormRequests'], []);
                const tasks = get(data, ['results', 'tasks'], []);
                yield put(
                    requestCaseAssignAgent.success({
                        ...caseInformation,
                        result: result ? JSON.parse(result) : null,
                        resultAgent: resultAgent ? JSON.parse(resultAgent) : null,
                        watchers,
                        subFormRequests,
                        tasks,
                    }),
                );
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
                callback && callback();
            } else {
                yield put(requestCaseAssignAgent.error({message: data.errors}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(requestCaseAssignAgent.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchRequestCaseAgentUnassigning() {
    while (true) {
        const {
            payload: {caseId, callback, showAlert},
        }: IActionType<RequestCaseUnassignedAgentType> = yield take(REQUEST_CASE_UNASSIGNED_AGENT.REQUEST);
        try {
            const data: RequesterCaseResponseTypes = yield call(http, `case/${caseId}/unassigned`, {
                method: 'POST',
            });
            if (data.success) {
                const caseInformation = get(data, ['results', 'case'], {});
                const watchers = get(data, ['results', 'watchers'], []);
                const tasks = get(data, ['results', 'tasks'], []);
                yield put(
                    requestCaseUnassignedAgent.success({
                        ...caseInformation,
                        watchers,
                        tasks,
                    }),
                );
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
                callback && callback();
            } else {
                yield put(requestCaseUnassignedAgent.error({message: data.errors}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(requestCaseUnassignedAgent.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchRequestCaseStatusChanging() {
    while (true) {
        const {
            payload: {status, caseId, showAlert, callback},
        }: IActionType<RequestCaseChangeStatusType> = yield take(REQUEST_CASE_CHANGE_STATUS.REQUEST);
        try {
            const data: RequesterCaseResponseTypes = yield call(http, `case/${caseId}/status`, {
                method: 'POST',
                body: JSON.stringify({
                    status: status,
                }),
            });
            if (data.success) {
                const caseInformation = get(data, ['results', 'case'], {});
                const tasks = get(data, ['results', 'tasks'], []);
                const subFormRequests = get(data, ['results', 'subFormRequests'], []);
                yield put(
                    requestCaseChangeStatus.success({
                        ...caseInformation,
                        tasks,
                        subFormRequests,
                    }),
                );
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else if (data.errors) {
                yield put(
                    requestCaseChangeStatus.error({
                        message: data.errors,
                    }),
                );
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            } else {
                yield put(requestCaseChangeStatus.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(requestCaseChangeStatus.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchRequestCaseChatActivation() {
    while (true) {
        const {
            payload: {caseId, callback, showAlert},
        }: IActionType<RequestCaseChatActivateRequestTypes> = yield take(REQUEST_CASE_CHAT_ACTIVATE.REQUEST);
        try {
            const data: RequesterCaseTypes = yield call(http, `case/${caseId}/chat`, {
                method: 'POST',
            });
            const caseInformation = get(data, ['case'], {});
            const result = get(data, ['case', 'result'], null);
            const resultAgent = get(data.result, ['case', 'resultAgent'], null);
            const checkedSections = get(data, 'checkedSections', []);
            const files = get(data, 'files', []);
            const chatFiles = get(data, 'chatFiles', []);
            const tags = get(data, 'tags', []);
            const templates = get(data, 'templates', []);
            const options = get(data, 'options', []);
            const invites = get(data, 'invites', []);
            if (data) {
                yield put(
                    requestCaseChatActivate.success({
                        ...caseInformation,
                        result: JSON.parse(result),
                        resultAgent: JSON.parse(resultAgent),
                        checkedSections,
                        files,
                        chatFiles,
                        tags,
                        templates,
                        options,
                        invites,
                    }),
                );
                callback ? callback() : showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(requestCaseChatActivate.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(requestCaseChatActivate.error({message: String(e)}));
        }
    }
}

function* watchRequestCasePinning() {
    while (true) {
        const {
            payload: {caseId, callback, showAlert},
        }: IActionType<RequestCaseChatActivateRequestTypes> = yield take(REQUEST_CASE_PINNING.REQUEST);
        try {
            const data: RequesterCaseTypes = yield call(http, `case/${caseId}/pin`, {
                method: 'POST',
            });
            const caseInformation = get(data, ['case'], {});
            const result = get(data, ['case', 'result'], null);
            const resultAgent = get(data, ['case', 'resultAgent'], null);
            const checkedSections = get(data, 'checkedSections', []);
            const files = get(data, 'files', []);
            const chatFiles = get(data, 'chatFiles', []);
            const tags = get(data, 'tags', []);
            const templates = get(data, 'templates', []);
            const options = get(data, 'options', []);
            const invites = get(data, 'invites', []);
            if (data) {
                yield put(
                    requestCaseChatActivate.success({
                        ...caseInformation,
                        result: JSON.parse(result),
                        resultAgent: JSON.parse(resultAgent),
                        checkedSections,
                        files,
                        chatFiles,
                        tags,
                        templates,
                        options,
                        invites,
                    }),
                );
                callback ? callback() : showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(requestCasePinning.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(requestCasePinning.error({message: String(e)}));
        }
    }
}

function* watchRequesterTagAdding() {
    while (true) {
        const {
            payload: {id, callback, showAlert, ...values},
        }: IActionType<RequestCaseTagRequestTypes> = yield take(REQUEST_CASE_ADD_TAG.REQUEST);
        try {
            const data: RequesterCaseTagResponseTypes = yield call(http, `tag/${id}/add`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(addRequesterTag.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(addRequesterTag.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(addRequesterTag.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchRequesterTagDeleting() {
    while (true) {
        const {
            payload: {id, callback, showAlert},
        }: IActionType<RequestCaseTagRequestTypes> = yield take(REQUEST_CASE_REMOVE_TAG.REQUEST);
        try {
            const data: RequesterCaseTagResponseTypes = yield call(http, `tag/${id}/remove`, {
                method: 'POST',
            });
            if (data.success) {
                yield put(deleteRequesterTag.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(deleteRequesterTag.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(deleteRequesterTag.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchArchiveGetting() {
    while (true) {
        const {
            payload: {id, callback},
        }: IActionType<RequesterCaseDownloadArchiveTypes> = yield take(REQUEST_CASE_ARCHIVE.REQUEST);
        try {
            const data: string | Blob = yield call(http, `user/case/file/download/${id}`, {
                method: 'GET',
                responseType: 'blob',
            });
            if (data) {
                yield put(requesterArchiveDownload.success(data));
                callback && callback(data);
            } else {
                yield put(requesterArchiveDownload.error({message: 'messages.error.somethingWentWrong'}));
            }
        } catch (e) {
            yield put(requesterArchiveDownload.error({message: String(e)}));
        }
    }
}

function* watchRequestCaseQuestion() {
    while (true) {
        const {
            payload: {id, readAt, showAlert, callback, toggleOutdatedInfo},
        }: IActionType<RequestCaseQuestionRequestTypes> = yield take(REQUEST_CASE_QUESTION.REQUEST);
        try {
            const data: RequestCaseQuestionResponseTypes = yield call(http, `case/${id}/question`, {
                method: 'POST',
                body: JSON.stringify({
                    readAt,
                }),
            });
            if (data.errors) {
                if (data.errors === ERROR_OUTDATED_INFORMATION) {
                    yield put(requestCaseQuestion.error({message: ERROR_OUTDATED_INFORMATION}));
                    toggleOutdatedInfo && toggleOutdatedInfo();
                } else {
                    yield put(requestCaseQuestion.error({message: 'messages.error.somethingWentWrong'}));
                    showAlert && showAlert(ALERT_TYPE_ERROR);
                }
            } else {
                yield put(requestCaseQuestion.success());
                callback && callback();
            }
        } catch (e) {
            yield put(requestCaseQuestion.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchRequestCaseActivities() {
    while (true) {
        const {
            payload: {id, showAlert},
        }: IActionType<RequesterCaseActivitiesRequestTypes> = yield take(REQUEST_CASE_ACTIVITIES.REQUEST);
        try {
            const data: RequesterCaseActivitiesResponseTypes = yield call(http, `case/${id}/activity`, {
                method: 'GET',
            });
            if (data.errors) {
                if (data.errors === ERROR_OUTDATED_INFORMATION) {
                    yield put(getRequestCaseActivities.error({message: ERROR_OUTDATED_INFORMATION}));
                } else {
                    yield put(getRequestCaseActivities.error({message: 'messages.error.somethingWentWrong'}));
                    showAlert && showAlert(ALERT_TYPE_ERROR);
                }
            } else {
                const results: RequesterCaseActivitiesTypes[] = get(data, 'results', []);
                yield put(getRequestCaseActivities.success(results));
            }
        } catch (e) {
            yield put(getRequestCaseActivities.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchRequestCaseActivitiesExport() {
    while (true) {
        const {
            payload: {id, showAlert, callback},
        }: IActionType<RequesterCaseActivitiesExportRequestTypes> = yield take(REQUEST_CASE_ACTIVITIES_EXPORT.REQUEST);
        try {
            const data: string | Blob = yield call(http, `case/${id}/activity/export`, {
                method: 'GET',
                responseType: 'blob',
            });
            if (data) {
                yield put(exportRequestCaseActivities.success(data));
                callback && callback(data);
            } else {
                yield put(requesterArchiveDownload.error({message: 'messages.error.somethingWentWrong'}));
            }
        } catch (e) {
            yield put(exportRequestCaseActivities.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchRequesterCaseAttachmentsForArchive() {
    while (true) {
        const {
            payload: {id, showAlert, callback},
        }: IActionType<RequesterCaseGettingTypes> = yield take(REQUEST_CASE_ATTACHMENTS_FOR_ARCHIVE.REQUEST);
        try {
            const data: RequesterCaseAttachmentsForArchiveResponseTypes = yield call(http, `case/${id}/attachments`, {
                method: 'GET',
            });
            if (data.errors) {
                yield put(getRequestCaseAttachmentsForArchive.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            } else {
                yield put(getRequestCaseAttachmentsForArchive.success(data.results));
                callback && callback();
            }
        } catch (e) {
            yield put(getRequestCaseAttachmentsForArchive.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchRequesterCaseWatcherAdding() {
    while (true) {
        const {
            payload: {id, callback, showAlert, ...values},
        }: IActionType<CaseWatcherCreatingTypes> = yield take(CREATE_CASE_WATCHER.REQUEST);
        try {
            const data: CaseWatcherResponseTypes = yield call(http, `watcher/${id}/create`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(createCaseWatcher.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(createCaseWatcher.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(createCaseWatcher.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchRequesterCaseWatcherRemoving() {
    while (true) {
        const {
            payload: {uuid, callback, showAlert},
        }: IActionType<CaseWatcherRemovingTypes> = yield take(DELETE_CASE_WATCHER.REQUEST);
        try {
            const data: CaseWatcherResponseTypes = yield call(http, `watcher/${uuid}/delete`, {
                method: 'DELETE',
            });
            if (data.success) {
                yield put(deleteCaseWatcher.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(deleteCaseWatcher.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(deleteCaseWatcher.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchRequesterCaseEmailRequest() {
    while (true) {
        const {
            payload: {id, showAlert, callback},
        }: IActionType<RequesterCaseEmailRequestTypes> = yield take(REQUESTER_CASE_EMAIL_REQUEST.REQUEST);
        try {
            const data: RequesterCaseEmailResponseTypes = yield call(http, `case/${id}/export/email`, {
                method: 'GET',
            });
            if (data.success) {
                yield put(requesterCaseEmailRequest.success());
                callback && callback(data.result);
            } else {
                yield put(requesterCaseEmailRequest.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(getRequestCaseAttachmentsForArchive.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchInviteAdditionalFormAdding() {
    while (true) {
        const {
            payload: {caseId, callback, showAlert, ...values},
        }: IActionType<InviteAdditionalFormCreateRequestTypes> = yield take(CREATE_ADDITIONAL_FORM_INVITE.REQUEST);
        try {
            const data: InviteAdditionalFormResponseTypes = yield call(http, `case/invite/${caseId}/create`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(createAdditionalFormInvite.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(createAdditionalFormInvite.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(createAdditionalFormInvite.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchInviteAdditionalFormRemoving() {
    while (true) {
        const {
            payload: {uuid, callback, showAlert},
        }: IActionType<InviteAdditionalFormDeleteRequestTypes> = yield take(DELETE_ADDITIONAL_FORM_INVITE.REQUEST);
        try {
            const data: InviteAdditionalFormResponseTypes = yield call(http, `case/invite/${uuid}/remove`, {
                method: 'DELETE',
            });
            if (data.success) {
                yield put(deleteAdditionalFormInvite.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(deleteAdditionalFormInvite.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(deleteAdditionalFormInvite.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchCaseHasTaskIgnoring() {
    while (true) {
        const {
            payload: {uuid, callback, showAlert},
        }: IActionType<CaseHasTaskIgnoringTypes> = yield take(IGNORE_CASE_HAS_TASK.REQUEST);
        try {
            const data: CaseHasTaskResponseTypes = yield call(http, `case/task/${uuid}/ignore`, {
                method: 'POST',
            });
            if (data.success) {
                yield put(ignoreCaseHasTask.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(ignoreCaseHasTask.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(ignoreCaseHasTask.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchSubFormRequestCreation() {
    while (true) {
        const {
            payload: {caseId, callback, showAlert, ...values},
        }: IActionType<InviteAdditionalFormCreateRequestTypes> = yield take(CREATE_SUBFORM_REQUEST.REQUEST);
        try {
            const data: SubFormRequestsResponseTypes = yield call(http, `case/subform/${caseId}/request`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(createSubFormRequest.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(createSubFormRequest.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(createSubFormRequest.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchSubFormRequestSubmitting() {
    while (true) {
        const {
            payload: {uuid, callback, showAlert},
        }: IActionType<SubFormRequestSubmittingRequestTypes> = yield take(SUBMIT_SUBFORM_REQUEST.REQUEST);
        try {
            const data: SubFormRequestsResponseTypes = yield call(http, `case/subform/${uuid}/submit`, {
                method: 'POST',
            });
            if (data.success) {
                yield put(submitSubFormRequest.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(submitSubFormRequest.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(submitSubFormRequest.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchSubFormRequestRemoving() {
    while (true) {
        const {
            payload: {uuid, callback, showAlert},
        }: IActionType<SubFormRequestDeleteRequestTypes> = yield take(DELETE_SUBFORM_REQUEST.REQUEST);
        try {
            const data: SubFormRequestsResponseTypes = yield call(http, `case/subform/${uuid}/remove`, {
                method: 'DELETE',
            });
            if (data.success) {
                yield put(deleteSubFormRequest.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(deleteSubFormRequest.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(deleteSubFormRequest.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchStatusChangingRequestUpdating() {
    while (true) {
        const {
            payload: {ruleUuid, caseId, showAlert, callback, ...values},
        }: IActionType<StatusChangeApproveUpdateRequestType> = yield take(UPDATE_STATUS_CHANGE_APPROVE_REQUEST.REQUEST);
        try {
            const data: RequesterCaseResponseTypes = yield call(http, `status/change/${ruleUuid}/update/${caseId}`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                const caseInformation = get(data, ['results', 'case'], {});
                yield put(
                    updateStatusChangeApproveRequest.success({
                        ...caseInformation,
                    }),
                );
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(updateStatusChangeApproveRequest.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(updateStatusChangeApproveRequest.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchStatusChangingRequestUnsetting() {
    while (true) {
        const {
            payload: {uuid, showAlert, callback},
        }: IActionType<UnsetStatusChangeApproveRequestType> = yield take(UNSET_STATUS_CHANGE_APPROVE_REQUEST.REQUEST);
        try {
            const data: StatusChangeApproveResponseType = yield call(http, `status/change/${uuid}/unset`, {
                method: 'GET',
            });
            if (data.success) {
                yield put(unsetStatusChangeApproveRequest.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(unsetStatusChangeApproveRequest.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(unsetStatusChangeApproveRequest.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchAllStatusChangingRequestsRemoving() {
    while (true) {
        const {
            payload: {id, showAlert, callback},
        }: IActionType<DeleteAllStatusChangeApproveRequestType> = yield take(
            DELETE_ALL_STATUS_CHANGE_APPROVE_REQUESTS.REQUEST,
        );
        try {
            const data: RequesterCaseResponseTypes = yield call(http, `status/change/${id}/remove/all`, {
                method: 'DELETE',
            });
            if (data.success) {
                yield put(deleteAllStatusChangeApproveRequests.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(deleteAllStatusChangeApproveRequests.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(deleteAllStatusChangeApproveRequests.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchGetRequesterCaseSlotsList() {
    while (true) {
        const {
            payload: {id, showAlert},
        }: IActionType<RequesterCaseSlotsListRequestTypes> = yield take(REQUESTER_CASE_SLOTS_LIST.REQUEST);
        try {
            const data: RequesterCaseSlotsResponseTypes = yield call(http, `case/slot/${id}/list`, {
                method: 'GET',
            });
            if (data.success) {
                yield put(getRequesterCaseSlotsList.success(data.results));
            } else {
                yield put(getRequesterCaseSlotsList.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(getRequesterCaseSlotsList.error({message: String(e)}));
        }
    }
}

function* watchGetRequesterCaseSlotsCreation() {
    while (true) {
        const {
            payload: {showAlert, id, callback, toggleSectionChecked, ...values},
        }: IActionType<RequesterCaseHasSlotCreationRequestTypes> = yield take(CREATE_REQUESTER_CASE_HAS_SLOT.REQUEST);
        try {
            const data: RequesterCaseSlotsResponseTypes = yield call(http, `case/slot/${id}/create`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(createRequesterCaseHasSlot.success(data.results));
                callback && callback();
            } else if (data.errors === ERROR_SECTION_ALREADY_CHECKED) {
                yield put(updateRequesterCase.error({message: ERROR_SECTION_ALREADY_CHECKED}));
                toggleSectionChecked && toggleSectionChecked();
            } else {
                yield put(createRequesterCaseHasSlot.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(createRequesterCaseHasSlot.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchGetRequesterCaseSlotsDeleting() {
    while (true) {
        const {
            payload: {showAlert, uuid, callback, toggleSectionChecked, ...values},
        }: IActionType<RequesterCaseHasSlotDeletingRequestTypes> = yield take(DELETE_REQUESTER_CASE_HAS_SLOT.REQUEST);
        try {
            const data: RequesterCaseSlotsResponseTypes = yield call(http, `case/slot/${uuid}/delete`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(deleteRequesterCaseHasSlot.success(data.results));
                callback && callback();
            } else if (data.errors === ERROR_SECTION_ALREADY_CHECKED) {
                yield put(updateRequesterCase.error({message: ERROR_SECTION_ALREADY_CHECKED}));
                toggleSectionChecked && toggleSectionChecked();
            } else {
                yield put(deleteRequesterCaseHasSlot.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(deleteRequesterCaseHasSlot.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchGetRequesterCaseBudgetsList() {
    while (true) {
        const {
            payload: {id, showAlert},
        }: IActionType<RequesterCaseBudgetsListRequestTypes> = yield take(REQUESTER_CASE_BUDGETS_LIST.REQUEST);
        try {
            const data: RequesterCaseBudgetsResponseTypes = yield call(http, `case/budget/${id}/list`, {
                method: 'GET',
            });
            if (data.success) {
                yield put(getRequesterCaseBudgetsList.success(data.results));
            } else {
                yield put(getRequesterCaseBudgetsList.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(getRequesterCaseBudgetsList.error({message: String(e)}));
        }
    }
}

function* watchRequesterCaseBudgetCreation() {
    while (true) {
        const {
            payload: {id, showAlert, callback, ...values},
        }: IActionType<RequesterCaseBudgetCreateRequestTypes> = yield take(CREATE_REQUESTER_CASE_BUDGET.REQUEST);
        try {
            const data: RequesterCaseBudgetsResponseTypes = yield call(http, `case/budget/${id}/create`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(createRequesterCaseBudget.success(data.results));
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
                callback && callback();
            } else {
                yield put(createRequesterCaseBudget.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(createRequesterCaseBudget.error({message: String(e)}));
        }
    }
}

function* watchRequesterCaseBudgetUpdating() {
    while (true) {
        const {
            payload: {uuid, showAlert, callback, ...values},
        }: IActionType<RequesterCaseBudgetUpdateRequestTypes> = yield take(UPDATE_REQUESTER_CASE_BUDGET.REQUEST);
        try {
            const data: RequesterCaseBudgetsResponseTypes = yield call(http, `case/budget/${uuid}/update`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(updateRequesterCaseBudget.success(data.results));
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
                callback && callback();
            } else {
                yield put(updateRequesterCaseBudget.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(updateRequesterCaseBudget.error({message: String(e)}));
        }
    }
}

function* watchRequesterCaseBudgetDeleting() {
    while (true) {
        const {
            payload: {uuid, showAlert},
        }: IActionType<RequesterCaseBudgetDeleteRequestTypes> = yield take(DELETE_REQUESTER_CASE_BUDGET.REQUEST);
        try {
            const data: RequesterCaseBudgetsResponseTypes = yield call(http, `case/budget/${uuid}/delete`, {
                method: 'DELETE',
            });
            if (data.success) {
                yield put(deleteRequesterCaseBudget.success(data.results));
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(deleteRequesterCaseBudget.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(deleteRequesterCaseBudget.error({message: String(e)}));
        }
    }
}

function* watchGetRequesterCaseCalendarsList() {
    while (true) {
        const {
            payload: {id, showAlert},
        }: IActionType<RequesterCaseCalendarsListRequestTypes> = yield take(REQUESTER_CASE_CALENDARS_LIST.REQUEST);
        try {
            const data: RequesterCaseCalendarsResponseTypes = yield call(http, `case/calendar/${id}/list`, {
                method: 'GET',
            });
            if (data.success) {
                yield put(getRequesterCaseCalendarsList.success(data.results));
            } else {
                yield put(getRequesterCaseCalendarsList.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(getRequesterCaseCalendarsList.error({message: String(e)}));
        }
    }
}

function* watchGetRequesterCaseTimeBucketsList() {
    while (true) {
        const {
            payload: {id, showAlert},
        }: IActionType<RequesterCaseTimeBucketsListRequestTypes> = yield take(REQUESTER_CASE_TIME_BUCKETS_LIST.REQUEST);
        try {
            const data: RequesterCaseTimeBucketsResponseTypes = yield call(http, `case/bucket/${id}/list`, {
                method: 'GET',
            });
            if (data.success) {
                yield put(getRequesterCaseTimeBucketsList.success(data.results));
            } else {
                yield put(getRequesterCaseTimeBucketsList.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(getRequesterCaseTimeBucketsList.error({message: String(e)}));
        }
    }
}

function* watchRequesterCaseCalendarCreation() {
    while (true) {
        const {
            payload: {id, showAlert, callback, ...values},
        }: IActionType<RequesterCaseCalendarCreateRequestTypes> = yield take(CREATE_REQUESTER_CASE_CALENDAR.REQUEST);
        try {
            const data: RequesterCaseCalendarsResponseTypes = yield call(http, `case/calendar/${id}/create`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(createRequesterCaseCalendar.success(data.results));
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
                callback && callback();
            } else {
                yield put(createRequesterCaseCalendar.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(createRequesterCaseCalendar.error({message: String(e)}));
        }
    }
}
function* watchRequesterCaseTimeBucketCreation() {
    while (true) {
        const {
            payload: {id, showAlert, callback, setErrors, ...values},
        }: IActionType<RequesterCaseTimeBucketCreateRequestTypes> = yield take(
            CREATE_REQUESTER_CASE_TIME_BUCKET.REQUEST,
        );
        try {
            const data: RequesterCaseTimeBucketsResponseTypes = yield call(http, `case/bucket/${id}/create`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(createRequesterCaseTimeBucket.success(data.results));
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
                callback && callback();
            } else {
                yield put(createRequesterCaseTimeBucket.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
                setErrors && setErrors(data.errors);
            }
        } catch (e) {
            yield put(createRequesterCaseTimeBucket.error({message: String(e)}));
        }
    }
}

function* watchRequesterCaseCalendarUpdating() {
    while (true) {
        const {
            payload: {uuid, showAlert, callback, ...values},
        }: IActionType<RequesterCaseCalendarUpdateRequestTypes> = yield take(UPDATE_REQUESTER_CASE_CALENDAR.REQUEST);
        try {
            const data: RequesterCaseCalendarsResponseTypes = yield call(http, `case/calendar/${uuid}/update`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(updateRequesterCaseCalendar.success(data.results));
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
                callback && callback();
            } else {
                yield put(updateRequesterCaseCalendar.error({message: 'messages.error.somethingWentWrong'}));
                if (typeof data.errors === 'string') {
                    showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
                } else if (data.errors && data.errors.resourceFieldCalendarBookframe) {
                    showAlert && showAlert(ALERT_TYPE_ERROR, data.errors.resourceFieldCalendarBookframe);
                }
            }
        } catch (e) {
            yield put(updateRequesterCaseCalendar.error({message: String(e)}));
        }
    }
}
function* watchRequesterCaseTimeBucketUpdating() {
    while (true) {
        const {
            payload: {uuid, showAlert, callback, setErrors, ...values},
        }: IActionType<RequesterCaseTimeBucketUpdateRequestTypes> = yield take(
            UPDATE_REQUESTER_CASE_TIME_BUCKET.REQUEST,
        );
        try {
            const data: RequesterCaseTimeBucketsResponseTypes = yield call(http, `case/bucket/${uuid}/update`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(updateRequesterCaseTimeBucket.success(data.results));
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
                callback && callback();
            } else {
                yield put(updateRequesterCaseTimeBucket.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
                setErrors && setErrors(data.errors);
            }
        } catch (e) {
            yield put(updateRequesterCaseTimeBucket.error({message: String(e)}));
        }
    }
}

function* watchRequesterCaseCalendarDeleting() {
    while (true) {
        const {
            payload: {uuid, showAlert},
        }: IActionType<RequesterCaseCalendarDeleteRequestTypes> = yield take(DELETE_REQUESTER_CASE_CALENDAR.REQUEST);
        try {
            const data: RequesterCaseCalendarsResponseTypes = yield call(http, `case/calendar/${uuid}/delete`, {
                method: 'DELETE',
            });
            if (data.success) {
                yield put(deleteRequesterCaseCalendar.success(data.results));
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(deleteRequesterCaseCalendar.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(deleteRequesterCaseCalendar.error({message: String(e)}));
        }
    }
}

function* watchUnavailableCalendarRangesGetting() {
    while (true) {
        const {
            payload: {uuid, showAlert, ...values},
        }: IActionType<CalendarUnavailableRangesRequestTypes> = yield take(GET_UNAVAILABLE_CALENDAR_RANGES.REQUEST);
        try {
            const data: CalendarUnavailableRangesResponseTypes = yield call(http, `case/calendar/${uuid}/unavailable`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(getUnavailableCalendarRanges.success(data.results));
            } else {
                yield put(getUnavailableCalendarRanges.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(getUnavailableCalendarRanges.error({message: String(e)}));
        }
    }
}

function* watchRequesterCaseTimeBucketDeleting() {
    while (true) {
        const {
            payload: {uuid, showAlert},
        }: IActionType<RequesterCaseTimeBucketUpdateRequestTypes> = yield take(
            DELETE_REQUESTER_CASE_TIME_BUCKET.REQUEST,
        );
        try {
            const data: RequesterCaseTimeBucketsResponseTypes = yield call(http, `case/bucket/${uuid}/delete`, {
                method: 'DELETE',
            });
            if (data.success) {
                yield put(deleteRequesterCaseTimeBucket.success(data.results));
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(deleteRequesterCaseTimeBucket.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(deleteRequesterCaseTimeBucket.error({message: String(e)}));
        }
    }
}

function* watchImpersonatedCaseCreation() {
    while (true) {
        const {
            payload: {id, showAlert, callback, setErrors, ...values},
        }: IActionType<ImpersonatedFormCreationRequestTypes> = yield take(CREATE_IMPERSONATED_CASE.REQUEST);
        try {
            const data: ImpersonatedCaseRedirectResponseTypes = yield call(http, `impersonated/case/${id}/create`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(createImpersonatedForm.success());
                callback && callback(data.caseId, data.formId);
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(createImpersonatedForm.error({message: 'messages.error.somethingWentWrong'}));
                setErrors && setErrors(data.errors);
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(createImpersonatedForm.error({message: String(e)}));
        }
    }
}

function* watchImpersonatedCaseDetailsUpdating() {
    while (true) {
        const {
            payload: {uuid, showAlert, callback, setErrors, ...values},
        }: IActionType<ImpersonatedFormUpdatingRequestTypes> = yield take(UPDATE_IMPERSONATED_CASE_DETAILS.REQUEST);
        try {
            const data: ImpersonatedFormUpdatingResponseTypes = yield call(http, `impersonated/case/${uuid}/update`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(updateImpersonatedCaseDetails.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(updateImpersonatedCaseDetails.error({message: 'messages.error.somethingWentWrong'}));
                setErrors && setErrors(data.errors);
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(updateImpersonatedCaseDetails.error({message: String(e)}));
        }
    }
}

function* watchImpersonatedCaseReassigning() {
    while (true) {
        const {
            payload: {id, showAlert, callback, ...values},
        }: IActionType<ImpersonatedFormCreationRequestTypes> = yield take(REASSIGN_IMPERSONATED_CASE.REQUEST);
        try {
            const data: ImpersonatedCaseRedirectResponseTypes = yield call(http, `impersonated/case/${id}/reassign`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(reassignImpersonatedCase.success());
                callback && callback(data.caseId, data.formId);
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(reassignImpersonatedCase.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR, data.errors);
            }
        } catch (e) {
            yield put(reassignImpersonatedCase.error({message: String(e)}));
        }
    }
}

export default [
    fork(watchGetAllRequesterCases),
    fork(watchGetAllRequesterCasesBackground),
    fork(watchCaseFilesRequestGetting),
    fork(watchCaseChatFilesRequestGetting),
    fork(watchGetRequesterCase),
    fork(watchGetRequesterCaseForClient),
    fork(watchGetTicketCase),
    fork(watchGetRequesterCaseDrawer),
    fork(watchGetRequesterCaseBackground),
    fork(watchGetRequesterCaseBackgroundForClient),
    fork(watchCreateTicket),
    fork(watchCreateRequestCase),
    fork(watchUpdateRequesterCase),
    fork(watchUpdateRequesterCaseAgentPage),
    fork(watchUpdateRequesterCaseOption),
    fork(watchUpdateRequesterCasePopupOption),
    fork(watchRequesterPreparedStatus),
    fork(watchUpdateCheckedSections),
    fork(watchUpdateCheckedSectionsForStack),
    fork(watchUploadFile),
    fork(watchUploadSignature),
    fork(watchDeleteSignature),
    fork(watchRequesterCasePopupsGetting),
    fork(watchRequesterPopupCreating),
    fork(watchRequesterPopupUpdating),
    fork(watchRequesterPopupDeleting),
    fork(watchDeleteProfileEntities),
    fork(watchEditProfileEntities),
    fork(watchRequestCaseAgentAssigning),
    fork(watchRequestCaseAgentUnassigning),
    fork(watchRequestCaseStatusChanging),
    fork(watchRequestCaseChatActivation),
    fork(watchRequestCasePinning),
    fork(watchRequesterTagAdding),
    fork(watchRequesterTagDeleting),
    fork(watchArchiveGetting),
    fork(watchRequestCaseQuestion),
    fork(watchRequestCaseActivities),
    fork(watchRequestCaseActivitiesExport),
    fork(watchRequesterCaseAttachmentsForArchive),
    fork(watchRequesterCaseWatcherAdding),
    fork(watchRequesterCaseWatcherRemoving),
    fork(watchRequesterCaseEmailRequest),
    fork(watchRequesterCaseToggleRemovingPossibility),
    fork(watchRequesterCaseCanceling),
    fork(watchRequesterCaseRemoving),
    fork(watchStatusChangingRequestUpdating),
    fork(watchStatusChangingRequestUnsetting),
    fork(watchAllStatusChangingRequestsRemoving),
    fork(watchInviteAdditionalFormAdding),
    fork(watchInviteAdditionalFormRemoving),
    fork(watchCaseHasTaskIgnoring),
    fork(watchSubFormRequestCreation),
    fork(watchSubFormRequestSubmitting),
    fork(watchSubFormRequestRemoving),
    fork(watchGetRequesterCaseSlotsList),
    fork(watchGetRequesterCaseSlotsCreation),
    fork(watchGetRequesterCaseSlotsDeleting),
    fork(watchGetRequesterCaseBudgetsList),
    fork(watchRequesterCaseBudgetCreation),
    fork(watchRequesterCaseBudgetUpdating),
    fork(watchRequesterCaseBudgetDeleting),
    fork(watchGetRequesterCaseCalendarsList),
    fork(watchRequesterCaseCalendarCreation),
    fork(watchRequesterCaseCalendarUpdating),
    fork(watchRequesterCaseCalendarDeleting),
    fork(watchUnavailableCalendarRangesGetting),
    fork(watchGetRequesterCaseTimeBucketsList),
    fork(watchRequesterCaseTimeBucketCreation),
    fork(watchRequesterCaseTimeBucketUpdating),
    fork(watchRequesterCaseTimeBucketDeleting),
    fork(watchImpersonatedCaseCreation),
    fork(watchImpersonatedCaseDetailsUpdating),
    fork(watchImpersonatedCaseReassigning),
];
